import React, { PropTypes } from 'react'
import { Link } from 'react-router'
import { reduxForm } from 'redux-form'
import FormMessages, { generateValidation } from 'redux-form-validation'

const validations = {
  email: {
    required: true,
    email: true,
    validateOnBlur: true
  },

  password: {
    required: true,
    minLength: 8
  },

  remember: {
    required: false
  }
}

const Login = ({
  fields: {
    email,
    password,
    remember
  },
  handleSubmit,
  submitting,
  error,
  children
}) => (
  <div className='login-form-container'>
    <p className={(error && !submitting) ? 'error' : 'error hidden'}>{error}</p>
    <form onSubmit={handleSubmit}>
      <div className='input-fields'>
        <input type='email' placeholder='Email' {...email} />
        <FormMessages tagName='ul' className='error-list' field={email}>
          <li when='required'>
            this field is required
          </li>
          <li when='email'>
            please insert a valid email
          </li>
        </FormMessages>
        <input type='password' placeholder='Password' {...password} />
        <FormMessages tagName='ul' className='error-list' field={password}>
          <li when='required'>
            this field is required
          </li>
          <li when='minLength'>
            password must be atleast 8 characters
          </li>
        </FormMessages>
      </div>
      <div className='remember-me-submit'>
        <label>
          <input type='checkbox' {...remember} />
          <span className='indicator' />
          Remember me
        </label>
        <button type='submit'>
          Login
        </button>
      </div>
    </form>
    <div className='forgot-password-link'>
      <Link to='/login/forgot-password'>Forgot password?</Link>
    </div>
    <div className='forgot-password-link'>
      <Link to='/privacy-policy'>Privacy Policy</Link>
    </div>
    {children}
  </div>
)

Login.propTypes = {
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.object,
  children: PropTypes.element
}

export default reduxForm({
  form: 'login',
  ...generateValidation(validations)
})(Login)



// WEBPACK FOOTER //
// ./src/components/login/login.js